import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DamageDocumentType } from 'app/models';
import { InsurenetInterfaceService } from '@core';
import { ShareableFn, toShareable } from '@co-3/ctrl-ui/common';

type InsuranceTypeId = number;

@Injectable({ providedIn: 'root' })
export class DamageDocumentTypesService {
    private requestCache = new Map<InsuranceTypeId, ShareableFn<DamageDocumentType[]>>();

    private insurenetInterfaceService = inject(InsurenetInterfaceService);

    public getDocumentTypes(insuranceTypeId: InsuranceTypeId): Observable<DamageDocumentType[]> {
        if (!this.requestCache.has(insuranceTypeId)) {
            this.requestCache.set(
                insuranceTypeId,
                toShareable(() => this.insurenetInterfaceService.getDamageDocumentTypes(insuranceTypeId)),
            );
        }
        return this.requestCache.get(insuranceTypeId)();
    }
}
